import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages, ProductType, RedOutlineComponent } from '@inter-ikea-storageone/range';
import { CollisionValidationResult, Entity } from '@inter-ikea-core/core';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import { hideAddTVSheet, showCollisionTVSheet } from '../TVFeature';

const addTV = ({ coreApi, dispatch, props }: BehaviorParameters) => {
  const coreProductId =
    props.tvPlacement === 'foot'
      ? 'tv_' + props.tvSize + '_black_foot'
      : 'tv_' + props.tvSize + '_black';

  const anyTvs = !!coreApi.entities.getByProductTypes([ProductType.TV, ProductType.TV_WITH_FOOT])
    .length;

  if (anyTvs) return;

  const placementResult = coreApi.products.add(coreProductId);

  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    const collisionResult =
      'collisions' in placementResult.errors[0]
        ? (placementResult.errors[0] as CollisionValidationResult)
        : null;
    if (collisionResult) {
      const collidingFrames = collisionResult.collisions
        .map(collision =>
          coreApi.entities.isProductType(collision.other, ProductType.BESTA_FRAME)
            ? collision.other
            : null
        )
        .filter(Boolean) as Entity[];
      collidingFrames.forEach(frame => frame.addComponent(new RedOutlineComponent()));
      dispatch(showCollisionTVSheet());
      const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
        ? ErrorMessages.NoFramesInScene
        : ErrorMessages.ItemWontFit;
      coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
      coreApi.entities.disposeCollidingEntities(placementResult.errors);
    }
  } else {
    dispatch(hideAddTVSheet());
  }
};

export { addTV };
